import React, { Component } from "react";
import OutfitListView from "presentational/common/outfitUnit/OutfitListView";
import TXT from "presentational/common/multinational/TXT";
import PropTypes from "prop-types";

class RootOutfitWithItemListView extends Component {
  static propTypes = {
    list: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isEnd: PropTypes.bool.isRequired,
    callNextListFn: PropTypes.func.isRequired
  };

  render() {
    const { list, isLoading, isEnd, callNextListFn } = this.props;

    return (
      <div>
        <OutfitListView
          list={list}
          isLoading={isLoading}
          isEnd={isEnd}
          callNextListFn={callNextListFn}
          emptyListText={<TXT name="msg_emptyListOutfitWithItem" />}
        />
      </div>
    );
  }
}

export default RootOutfitWithItemListView;
